module.exports = __webpack_public_path__ + "img/zookeeper.be0bdbfd.svg";